import type { AudienceType } from '@/audience/main/model/AudienceViewModels';

export enum CampaignStatusGroupEnum {
  READY = 'r',
  WAIT = 'w',
  OPERATE = 'o',
  STOP = 's',
}

export enum CampaignStatusEnum {
  TEMPSAVE = 'r1',
  MODIFY = 'r2',
  REVIEW = 'w1',
  PENDING = 'w2',
  ONGOING = 'o1',
  COMPLETE = 'o2',
  HALTBEFORE = 's1',
  HALTAFTER = 's2',
  EXPIRED = 's3',
}

export enum RepeatTypeEnum {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  QUARTER = 'quarter',
  HALFYEAR = 'half_year',
  //YEARLY = "yearly",
}

export enum CampaignMediaEnum {
  KAKAO_BRANDMESSAGE = 'kft',
  TEXT_MESSAGE = 'tms',
}

export enum SendtypeEnum {
  ONETIME = 'onetime',
  RECURRING = 'recurring',
}

export enum CampaignProgressEnum {
  BASE_COMPLETE = 'base_complete',
  SET_COMPLETE = 'set_complete',
  MESSAGE_COMPLETE = 'message_complete',
  DESCRIPTION_COMPLETE = 'decription_complete',
}

export enum CampaignTimelineTypeEnum {
  CAMPAIGN_EVENT = 'campaign_event',
  STATUS_CHANGE = 'status_change',
  APPROVAL = 'approval',
  SEND_REQUEST = 'send_request',
  HALT_MSG = 'halt_msg',
  SEND_REQUEST_SUCCESS = 'send_request_success',
  SEND_SUCCESS = 'send_success',
}

export enum MsgDeliveryVendorEnum {
  SSG = 'ssg',
  DAU = 'dau',
}

export enum KakaoTalkType {
  TEXT = 'text',
  IMAGE_GENERAL = 'image_general',
  IMAGE_WIDE = 'image_wide',
}

export enum KakaoButtonLinkEnum {
  NAME = 'name',
  WEB_LINK = 'web_link',
  APP_LINK = 'app_link',
}

export enum KakaoButtonTypeEnum {
  WEB_LINK_BUTTON = 'web_link_button',
  SHIPMENT_TRACKING_BUTTON = 'shipment_tracking_button',
  ADD_CHANNEL_BUTTON = 'add_channel_button',
}

export enum MessageTypeEnum {
  SMS = 'sms',
  LMS = 'lms',
  MMS = 'mms',
  KAKAO_TEXT = 'kakao_text',
  KAKAO_IMAGE_GENERAL = 'kakao_image_general',
  KAKAO_IMAGE_WIDE = 'kakao_image_wide',
  KAKAO_CAROUSEL = 'kakao_carousel',
}

export function messageTypeEnum_hasSendPhoneNumber(messageType: MessageTypeEnum) {
  return messageType == MessageTypeEnum.SMS || messageType == MessageTypeEnum.LMS || messageType == MessageTypeEnum.MMS;
}

export enum SetGroupCategoryEnum {
  AGE = 'age',
  REP_NM = 'rep_nm',
  PURPOSE = 'purpose',
  PURPOSE_LV2 = 'purpose_lv2',
}

export enum PurposeEnum {
  STARTER = 'nepa_starter',
  MOUNTAINEERING = 'mountaineering',
  LIFE_TREKKING = 'lifestyle_causual&easy_trekking',
  LIFE_CASUAL = 'lifestyle_casual',
  TREKKING_ATHLESURE = 'easy_trekking&athlesure',
}

export interface CampaignRemind {
  remind_step: number;
  remind_media: CampaignMediaEnum;
  remind_duration: number;
}

export interface CampaignRemindCreate {
  remind_step: number;
  remind_duration: number;
  created_at: string; // iso date string
  created_by: string | number | null;
  updated_at: string; // iso date string
  updated_by: string | number | null;
}

export interface CampaignSetGroup {
  set_group_seq: number | null;
  group_sort_num: number | null;
  set_seq: number | null;
  media: CampaignMediaEnum;
  msg_type: MessageTypeEnum;
  recipient_group_rate: number | null;
  recipient_group_count: number | null;
  set_group_category: SetGroupCategoryEnum;
  set_group_val: string;
  rep_nm: string | null;
  is_control_group: boolean | null;
}

export interface CampaignSet {
  set_seq: number | string | null;
  set_sort_num: number;
  is_group_added: boolean | null;
  recsys_model_id: number | null;
  audience_id: string;
  audience_name: string | null;
  audience_count: number | null;
  audience_portion: number | null;
  audience_unit_price: number | null;
  response_rate: number | null;
  rep_nm_list: string[] | null;
  recipient_count: number | null; //수신자수(발송 수)
  medias: string | null; // CampaignMediaEnum comma string
  is_confirmed: boolean | null;
  is_message_confirmed: boolean | null;
  media_cost: number | null;
}

export interface CampaignSummary {
  recipient_portion: number;
  recipient_descriptions: string[];
  fatigue_excluded_count?: number | null;
}

export interface CampaignBase {
  campaign_name: string;
  budget: number | null;
  campaign_status_group_code: CampaignStatusGroupEnum;
  campaign_status_group_name: string;
  campaign_status_code: CampaignStatusEnum;
  campaign_status_name: string;
  send_type_code: SendtypeEnum;
  send_type_name: string;
  repeat_type: RepeatTypeEnum | null;
  week_days: string | null;
  send_date: string | null;
  is_msg_creation_recurred: boolean;
  is_approval_recurred: boolean;
  datetosend: number | 'end_of_month' | null;
  timetosend: string;
  start_date: string | null;
  end_date: string | null;
  group_end_date: string | null;
  has_remind: boolean;
  remind_list: CampaignRemind[] | null;
  audience_type_code: AudienceType | null;
  is_personalized: boolean;
  msg_delivery_vendor: MsgDeliveryVendorEnum;
  campaigns_exc: string[] | null;
  audiences_exc: string[] | null;
  shop_send_yn: 'y' | 'n'; // step4에서 매장용인지 체크하는 프러퍼티
  retention_day?: number | null; // 주기성 캠페인의 유지기간 (1~90일 선택)
  fatigue_days?: number | null;
  fatigue_counts?: number | null;
  create_department_id: number;
  create_department_name: string;
  is_update_allowed: boolean;
  progress: CampaignProgressEnum;
  created_at: string; // iso date string
  created_by: string | number | null;
  updated_at: string; // iso date string
  updated_by: string | number | null;
}

export interface CampaignObjectCreateReq {
  campaign_name: string;
  budget: number | null;
  send_type_code: SendtypeEnum;
  repeat_type: RepeatTypeEnum | null;
  week_days: string | null;
  send_date: string | null;
  is_msg_creation_recurred: boolean;
  is_approval_recurred: boolean;
  datetosend: number | 'end_of_month' | null;
  timetosend: string;
  start_date: string | null;
  end_date: string | null;
  group_end_date: string | null;
  retention_day?: number | null; // 주기성 캠페인의 유지기간 (1~90일 선택)
  fatigue_days?: number | null;
  fatigue_counts?: number | null;
  has_remind: boolean;
  remind_list: CampaignRemind[] | null;
  is_personalized: boolean;
  msg_delivery_vendor: MsgDeliveryVendorEnum;
  campaigns_exc: string[] | null;
  audiences_exc: string[] | null;
}

export interface CampaignReadBase extends CampaignBase {
  campaign_id: string;
  campaign_group_id: string;
}

export type KakaoButtonLink = {
  set_group_msg_seq: number | null;
  button_name: string;
  button_type: KakaoButtonTypeEnum;
  web_link: string | null;
  app_link: string | null;
};
export type KakaoCarouselMoreLink = {
  url_pc?: string;
  url_mobile: string;
};
export type KakaoCarouselButtonLink = {
  id: number;
  name: string;
  type: 'web';
  url_pc: string;
  url_mobile: string;
};
export type KakaoCarouselItem = {
  id: number;
  set_group_msg_seq: number;
  carousel_sort_num: number;
  message_title: string;
  message_body: string;
  image_url: string;
  image_title: string;
  image_link: string;
  s3_image_path: string;
  carousel_button_links: KakaoCarouselButtonLink[];
};
export interface Message {
  set_group_msg_seq: number; // 메시지 아이디
  msg_resv_date: string; // 메시지 발송일자
  msg_title: string; // 제목
  msg_body: string; // 본문
  bottom_text: string | null; // 하단메시지
  msg_announcement: string; // 알림메시지
  template_id: number | null; // 카카오 메시지 템플릿 키
  msg_gen_key: string;
  msg_photo_uri: null | string[]; // # MMS3개/카카오1개
  msg_send_type: string;
  media: CampaignMediaEnum;
  msg_type: MessageTypeEnum;
  kakao_button_links: KakaoButtonLink[] | null;
  phone_callback: string;
  is_used: boolean;
  kakao_carousel_more_link: KakaoCarouselMoreLink | null;
  kakao_carousel: KakaoCarouselItem[] | null;
}

export type PreviewMessage = {
  msg_title: string; // 제목
  msg_body: string; // 본문
  bottom_text: string | null; // 하단메시지
  msg_announcement: string; // 알림메시지
  msg_photo_uri: null | string[]; // # MMS3개/카카오1개
  media: CampaignMediaEnum;
  msg_type: MessageTypeEnum;
  kakao_button_links: KakaoButtonLink[] | null;
  phone_callback: string;
};

export interface CampaignMessage extends Message {
  rec_explanation: string[]; // 본문
}

export interface RemindMessage extends Message {
  remind_step: number;
  remind_seq: number;
}

export interface SetGroupMessage {
  set_seq: number;
  set_group_seq: number;
  group_sort_num: number;
  campaign_msg: CampaignMessage;
  remind_msg_list: RemindMessage[] | null;
}

export interface CampaignReviewerObject {
  approval_no: number;
  user_id: number;
  user_name_object: string;
  test_callback_number: string;
  is_approved: boolean;
}

export interface CampaignObjectRes {
  progress: CampaignProgressEnum;
  base: CampaignReadBase;
  set_summary: CampaignSummary | null;
  set_list: CampaignSet[] | null;
  set_group_list: CampaignSetGroup[] | null;
  set_group_message_list: Record<number, SetGroupMessage[]> | null;
  reviewers: CampaignReviewerObject[];
}

export interface PutCampaignSetGroupRes {
  campaign_set: CampaignSet;
  campaign_set_group_list: CampaignSetGroup[];
}

export interface SendUserObject {
  user_name_object: string;
  test_callback_number: string;
}

export interface PersonalVariableObject {
  variable_id: number;
  variable_name: string;
  variable_symbol: string;
  variable_example: string | null;
  variable_option: string | null;
}

export interface MsgResourceObject {
  resource_id: number;
  img_uri: string;
  link_url: string | null;
}

export interface CampaignSetDescription {
  set_seq: number | null;
  set_sort_num: number | null;
  audience_id: string;
  audience_name: string;
  audience_count: number;
  audience_portion: number;
  audience_unit_price: number;
  response_rate: number;
  recipient_count: number;
  control_group_recipient_count: number;
  send_recipient_count: number;
  medias: string | null;
  media_cost: number | null;
  is_confirmed: boolean | null;
}

export interface CampaignSetGroupConfirm {
  campaign_set: CampaignSetDescription[];
  set_group_message_list: { [set_seq: number]: SetGroupMessage[] } | null;
}

export interface ReviewerObject {
  user_id: number;
  user_name_object: string;
  test_callback_number: string;
  default_reviewer_yn: 'y' | 'n';
}

export interface CampaignSummaryRes {
  send_type_code: string;
  send_type_name: string;
  total_reciepient: number;
  budget: number;
  repeat_type: string | null;
  week_days: string | null;
  start_date: string | null;
  end_date: string | null;
  send_date: string | null;
  campaign_status_code: string;
  campaign_status_name: string;
  msg_type_count: number;
  msg_type_tup: MessageTypeEnum[];
  audience_count: number;
  contents_count: number;
  campaign_msg_resv_date: string; // "2024-05-13 11:00"
  remind_step1_resv_date: string; // "2024-05-13 11:00",
  remind_step2_resv_date: string; // "2024-05-13 11:00",
  remind_step3_resv_date: string; // "2024-05-13 11:00"
}

export interface ExclDetailStat {
  div: string; // 컬럼명: 제외 구분
  id: string; // 컬럼명: ID
  name: string; // 컬럼명: 제외 그룹명
  count: string; // 컬럼명: 제외 고객수(명)
}

export interface ExclusionCustDetail {
  excl_message: string;
  excl_detail_stats: ExclDetailStat[];
}

export interface CustomerCampaignMessageHistory {
  send_date: string;
  campaign_id: string;
  campaign_name: string;
  audience_id: string;
  audience_name: string;
  is_purchase: string;
  send_message_body: string;
}
